import type {Values} from "@wix/devzai-utils-common";

export const DoppeViewerInvocationSource = {
    DoppeApp: 'InDoppeApp',
    DoppeViewerDomain: 'OnDoppeViewerDomain',
    WixRouter: 'WixRouter',
    SystemPage: 'SystemPage',
} as const;

export type DoppeViewerInvocationSource = Values<typeof DoppeViewerInvocationSource>;